<mat-card class="mt-3">
    <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image">
            <img *ngIf="currentAsset.host && currentAsset.host.manufacturer && currentAsset.host.icon"
                 [matTooltip]="currentAsset.host.manufacturer"
                 class="mat-32" src="/assets/images/os/{{currentAsset.host.icon}}"
                 alt="{{currentAsset.host.host_name}}">
            <img *ngIf="currentAsset.host && !currentAsset.host.manufacturer && currentAsset.host.icon"
                 class="mat-32" src="/assets/images/os/{{currentAsset.host.icon}}"
                 alt="{{currentAsset.host.host_name}}">
        </div> -->
        <mat-card-subtitle class="mr-3 col-md-12" *ngIf="sourceColumnName && !reportBuilder">
          Total Row(s) Count : {{rowGlData && rowGlData.length > 0 ? rowGlData.length : 0}} <br/>
          Filtered Row Count : {{ filteredRowCount }} 
          <!-- <br />
          Source Column Name: {{sourceColumnName}} -->
        </mat-card-subtitle>

        <ng-container *ngIf="!reportBuilder">
          <mat-form-field class="col-lg-3 mat-small">
            <mat-label>Quick Search (Press Enter To Search)</mat-label>
            <input matTooltip="Press Enter To Search"
                   placeholder="Enter value and press enter to search" matInput name="searchRec"
                   [(ngModel)]="searchRec" (keydown.enter)="applyFilter()">
            <mat-icon class="pointer" (click)="applyFilter()" matSuffix>search</mat-icon>
          </mat-form-field>
          <button mat-mini-fab matTooltip="Clear text" color="basic" (click)="clearSelectedRecords();">
            <a (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Rotate ms-fontColor-themePrimary"></i></a>
          </button>

          <div class="col-md-6 text-right">
            <mat-checkbox #selectedOnly matTooltip="Download Selected Rows Only" [(ngModel)]="checked" class="mr-3 example-margin"></mat-checkbox>
            <!-- <mat-checkbox *ngIf="glview" (ngModelChange)="clickedAllRecords($event)" matTooltip="Show All Records" class="mr-2 example-margin">All Records</mat-checkbox> -->
            <button *ngIf="glview" mat-mini-fab class="mr-2" color="basic" matTooltip="Refresh Table" (click)="cs.refreshTable(); $event.preventDefault();">
              <a (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Refresh"></i></a>
            </button> 
            <button *ngIf="checked" [matMenuTriggerFor]="srMenu" color="basic" mat-mini-fab class="mr-2" matTooltip="Download Selected Records">
              <a href="#" (click)="$event.preventDefault();"><i class="ms-Icon ms-Icon--CloudDownload ms-fontColor-themePrimary"></i></a>
            </button>
            <mat-menu class="mat_menu" #srMenu="matMenu">
              <button matTooltip="download as .xlsx" color="basic" mat-menu-item (click)="downloadSelectedRecords('excel')">
                <span class="pointer"><img src="../../../assets/images/microsoft-excel.png" alt="Excel" class="mat-32"></span> Excel
              </button>
              <button matTooltip="download as .csv" color="basic" mat-menu-item (click)="downloadSelectedRecords('csv')">
                <span class="pointer"><img src="../../../assets/images/csv.png" alt="CSV" class="mat-32"></span> Csv
              </button>
            </mat-menu>
            <button *ngIf="!checked" mat-mini-fab color="basic" class="mr-2" [matMenuTriggerFor]="menu" matTooltip="Download All Records">
              <a href="#" (click)="$event.preventDefault();"><i class="ms-Icon ms-Icon--CloudDownload ms-fontColor-themePrimary"></i></a>
            </button>
            <mat-menu class="mat_menu" #menu="matMenu">
                <button matTooltip="download as .xlsx" color="basic" mat-menu-item (click)="downloadFromAgGrid('excel')">
                  <span class="pointer"><img src="../../../assets/images/microsoft-excel.png" alt="Excel" class="mat-32"></span> Excel
                </button>
                <button matTooltip="download as .csv" color="basic" mat-menu-item (click)="downloadFromAgGrid('csv')">
                  <!-- <img class="donwload" src="../../../assets/images/reports/csv.png" alt="csv" /> -->
                  <span class="pointer"><img src="../../../assets/images/csv.png" alt="CSV" class="mat-32"></span> Csv
                </button>
            </mat-menu>
            <button mat-mini-fab class="mr-2" color="basic" matTooltip="Save Remarks">
              <a (click)="saveRemarks(); $event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Save ms-fontColor-themePrimary"></i></a>
            </button>
            <button mat-mini-fab class="" color="basic" matTooltip="Save Table" (click)="saveGridTableSettings(); $event.preventDefault();">
              <a (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--Table"></i></a>
            </button> 
              <button mat-mini-fab class="ml-2" color="basic" matTooltip="Hold/UnHold the Records" (click)="cs.holdOptionForSap(selectedRow); $event.preventDefault()">
                <a *ngIf="isLocked" (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--LockSolid"></i></a>
                <a *ngIf="!isLocked" (click)="$event.preventDefault();" href="#"><i class="ms-Icon ms-Icon--UnlockSolid"></i></a>
              </button>
            <!--  cs.saveTableFromAgGrid(); -->
            <!-- <button mat-mini-fab class="mr-2" color="basic" matTooltip="Add Column">
              <a (click)="cs.addColumnFromAgGrid(); $event.preventDefault();" href="#"><mat-icon>add_box</mat-icon></a>
            </button> -->
            <!-- <button mat-mini-fab color="basic" matTooltip="All Filter">
              <a (click)="selectAllFiltered($event); $event.preventDefault();" href="#"><mat-icon>checkbox</mat-icon></a>
            </button> -->
          </div>
        </ng-container>

        <ng-container *ngIf="reportBuilder">
          
        </ng-container>
    </mat-card-header>

    <mat-card-content>
        <ag-grid-angular *ngIf="glcountview"
          #glCoutGrid
          id="glCountGrid"
          style="width: 100%; height: 400px;"
          class="ag-theme-alpine"
          [allowDragFromColumnsToolPanel]="true"
          [autoGroupColumnDef]="autoGroupColumnDef"
          [columnDefs]="columnGlData"
          [columnTypes]="columnTypes"
          [cacheQuickFilter]="true"
          [defaultColDef]="defaultColDef"
          [groupSelectsChildren]="true"
          [gridOptions]="gridOptions"
          [rowData]="rowGlData"

          [rowGroupPanelShow]="rowGroupPanelShow"
          [sideBar]= "true"
          [suppressFieldDotNotation]="true"
          [suppressAggFuncInHeader]="true" 
          [suppressRowClickSelection]="true"
          [undoRedoCellEditing]="true"
          (filterChanged)="onFilterChanged($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          (cellClicked)="onCellClicked($event)"
          (gridReady)= "onGridReady($event, 'glcount')"
          (selectionChanged)="onSelectionChanged($event);"
          (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
        >
        </ag-grid-angular>
        <ag-grid-angular *ngIf="reportBuilder"
          #glCoutGrid
          id="glCountGrid"
          style="width: 100%; height: 400px;"
          class="ag-theme-alpine"
          [allowDragFromColumnsToolPanel]="true"
          [autoGroupColumnDef]="autoGroupColumnDef"
          [columnDefs]="columnGlData"
          [columnTypes]="columnTypes"
          [cacheQuickFilter]="true"
          [defaultColDef]="defaultColDef"
          [groupSelectsChildren]="true"
          [gridOptions]="gridOptions"
          [rowData]="rowGlData"

          [rowGroupPanelShow]="rowGroupPanelShow"
          [sideBar]= "true"
          [suppressFieldDotNotation]="true"
          [suppressAggFuncInHeader]="true" 
          [suppressRowClickSelection]="true"
          [undoRedoCellEditing]="true"
          (filterChanged)="onFilterChanged($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          (cellClicked)="onCellClicked($event)"
          (gridReady)= "onGridReady($event, 'glcount')"
          (selectionChanged)="onSelectionChanged($event);"
          (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
        >
        </ag-grid-angular>
    </mat-card-content>
</mat-card>

